<div [@flyInOut]="'in'" class="alert alert-{{ type }} alert-dismissible fade show" role="alert" *ngIf="type && message">
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
    {{ message }}
</div>
